import { InfinityScrollButton } from './infinity-scroll-button'

export default InfinityScrollButton
